import {
  MetaViewModel,
  VehicleListFiltersViewModel,
  VehicleOfficeSearchViewModel,
} from '@api/index';
import { VehicleListFiltersKeyValueViewModel } from '@api/models/VehicleListFiltersKeyValueViewModel';
import { VehicleListViewModel } from '@api/models/VehicleListViewModel';
import { CAR_RENTAL_FILTER_QUERY_PARAM_KEYS } from '@page/carRental/list/constants';

/**
 * Get parsed list data
 * @param data VehicleListViewModel
 * @returns object
 */
export const getParsedListData = (data?: VehicleListViewModel) => {
  let priceRangeMin = 0;
  let priceRangeMax = 0;

  const priceRanges = data?.filters?.find(
    (filter) => filter?.type === CAR_RENTAL_FILTER_QUERY_PARAM_KEYS.PRICE_RANGE
  );

  if (priceRanges) {
    priceRangeMin =
      parseInt(
        priceRanges?.items?.find((item) => item?.key === 'min')?.value as string
      ) || 0;

    priceRangeMax =
      parseInt(
        priceRanges?.items?.find((item) => item?.key === 'max')?.value as string
      ) || 0;
  }

  return {
    vehicles: data?.data || [],
    filters: data?.filters || [],
    meta: data?.meta || ({} as MetaViewModel),
    priceRanges: [priceRangeMin, priceRangeMax + 1],
  };
};

/**
 * Get filter by key
 * @param key string
 * @returns Array<VehicleListFiltersKeyValueViewModel>
 * @example
 * const fuelTypes = getFilterByKey(filtersResponse, 'fuelTypes');
 */
export const getFilterByKey = (
  filters: VehicleListFiltersViewModel[],
  key: string
): Array<VehicleListFiltersKeyValueViewModel> =>
  filters.find((filter) => filter.type === key)?.items || [];

/**
 * Get selected key by key name
 * @param keyName string
 * @returns Array<number>
 * @example
 * const selectedFuelTypes = getSelectedKeyByKeyName(filtersResponse, 'fuelTypes');
 */
export const getSelectedKeyByKeyName = (
  filters: VehicleListFiltersViewModel[],
  keyName: string
): Array<number> =>
  filters
    .find((filter) => filter.type === keyName)
    ?.items.filter((item) => item.selected)
    .map((item) => item.key) || [];

export const getPriceRange = (filters: VehicleListFiltersViewModel[]) => {
  let priceRangeMin = 0;
  let priceRangeMax = 0;

  const priceRanges = filters?.find(
    (filter) => filter?.type === CAR_RENTAL_FILTER_QUERY_PARAM_KEYS.PRICE_RANGE
  );

  if (priceRanges) {
    priceRangeMin =
      parseInt(
        priceRanges?.items?.find((item) => item?.key === 'min')?.value as string
      ) || 0;

    priceRangeMax =
      parseInt(
        priceRanges?.items?.find((item) => item?.key === 'max')?.value as string
      ) || 0;
  }

  return {
    priceRanges: [priceRangeMin, priceRangeMax + 1],
  };
};

export const getVehicleName = (
  vehicle: VehicleOfficeSearchViewModel | null
): string => {
  if (!vehicle) return '';

  const text = vehicle.text ?? '';

  return text.trim();
};
